import { Component, inject, input } from '@angular/core';
import { ModalService } from '../../../../../services/modals/modal.service';
import { faCircleCheck, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

export const PASSWORD_RESET_RESULTS_MODAL_NAME = 'password-reset-results';

@Component({
  selector: 'app-password-reset-results',
  imports: [FontAwesomeModule],
  templateUrl: './password-reset-results.component.html',
  styleUrl: './password-reset-results.component.scss'
})
export class PasswordResetResultsComponent {
  private readonly modalService = inject(ModalService);

  protected success = input(false);

  protected icons = {
    faCircleCheck: faCircleCheck,
    faCircleExclamation: faCircleExclamation,
  }

  protected closeModal() {
    this.modalService.closeModal(PASSWORD_RESET_RESULTS_MODAL_NAME);
  }
}
